<template>
  <div>
    <v-container >
      <CRUDList
        :canAdd="canAddToSharedList"
        :canEdit="true"
        :canSave="canEditSharedList"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        toolbarTitle="Tax District"
        @loadCRUDList="handleLoadCRUDList"
        @upsertItem="upsrtTransaction"
        :defaultSortBy="sortBy"
        :loadingData="gridLoading.flag"
        :loadingText="gridLoading.text"
      >
        <template v-slot:[`editedItem`]="{}">
          <taxDistrictEditedItem
            :baseCrudKey="baseCrudKey"
          />
        </template>
      </CRUDList>
    </v-container>
  </div>
</template>

<script>
import {
  mapGetters,
  mapActions,
  mapMutations,
} from 'vuex';
import CRUDList from '../../common/base/crud/CRUDList.vue';
import taxDistrictEditedItem from './taxDistrictEditedItem.vue';
import {
  defaultGridLoading, manageGridLoading,
  extractId,
} from '../../../util/shared/vue-global';
import {
  toFiscalYear,
} from '../../../util/shared/tmc-global';
import SharedListAccessControlMixin from '../SharedListAccessControl.mixin';

const getHeaders = () => {
  const headers = [
    { text: 'Tax District', value: 'districtCode' },
    { text: 'Name', value: 'districtName' },
    { text: 'Tax Unit', value: 'taxUnit.toUnitDescForAppro' },
    { text: 'Joint', value: 'isJointCounty', formatter: 'boolToStr' },
    { text: 'Remit', value: 'isRemitFund', formatter: 'boolToStr' },
    { text: 'ADA', value: 'ada' },
    { text: 'TIF Base', value: 'isTifBase' },
    { text: 'TIF Dist', value: 'isTifDistribution' },
  ];
  return headers;
};

/* As per business 'B' section not represent ADA it represent ABT and MV
  So on UI we are skipping 'averageDailyAttendence' values for ADA.
  And isRequiredAdaForCalculation flag is also deciding to display ADA.
*/
const getAdaFromTaxUnitRecord = (record) => ((record.taxUnit && record.taxUnit.appSection !== 'B') && record.isRequiredAdaForCalculation ? record.taxUnit.averageDailyAttendence : null);

const postProcessTaxDistrict = (records) => {
  const updatedRecords = [];
  records.forEach((record) => {
    const updatedRecord = { ...record };
    updatedRecord.ada = getAdaFromTaxUnitRecord(updatedRecord);
    updatedRecords.push(updatedRecord);
  });
  return updatedRecords;
};

export default {
  name: 'taxDistrictList',
  mixins: [SharedListAccessControlMixin],
  components: {
    CRUDList,
    taxDistrictEditedItem,
  },
  data: () => ({
    baseCrudKey: 'sharedTaxDistrict',
    headers: [],
    gridLoading: defaultGridLoading(),

    sortBy: [
      {
        column: 'districtCode',
        direction: 'desc',
      },
    ],
  }),
  created() {
    this.headers = getHeaders();
    this.initCriteria();
    this.loadLists();
  },
  computed: {
    ...mapGetters('base/crud', [
      'criteria',
      'index',
      'item',
    ]),
    ...mapGetters(['todaysDate']),
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    currentFiscalYear() {
      return toFiscalYear(new Date(this.todaysDate));
    },
  },
  methods: {
    manageGridLoading,
    ...mapActions('shared/taxDistrict', [
      'loadTaxDistrict',
      'upsertTaxDistrict',
    ]),
    ...mapActions('shared/taxUnit', [
      'loadTaxUnit',
      'loadMaxFiscalYear',
    ]),
    ...mapMutations('base/crud', [
      'setCriteria',
    ]),
    initCriteria() {
      // reset criteria while merge flag is true
      this.criteriaState = {};
    },
    async handleLoadCRUDList() {
      const { baseCrudKey } = this;
      const criteria = { ...this.criteriaState };
      const maxFiscalYear = await this.loadMaxFiscalYear() || this.currentFiscalYear;

      if (maxFiscalYear) {
        criteria.fiscalYear = maxFiscalYear;
      }

      manageGridLoading(this, true, 'Searching...');
      this.loadTaxDistrict({
        criteria,
        baseCrudKey,
        postProcessTaxDistrict,
      }).finally(() => {
        manageGridLoading(this, false);
      });
    },
    async upsrtTransaction(item) {
      const { baseCrudKey } = this;
      const updatedItem = { ...item };
      delete updatedItem.ada;
      if (updatedItem.taxUnit) {
        updatedItem.taxUnit = extractId(updatedItem.taxUnit);
      }
      await this.upsertTaxDistrict({ item: updatedItem, baseCrudKey });
    },
    newItemDialog() {
      let newItem = {};
      newItem = {
        districtCode: '',
        districtName: '',
        isJointCounty: '',
        isRemitFund: '',
        taxUnit: null,
      };
      return newItem;
    },
    async loadLists() {
      const maxFiscalYear = await this.loadMaxFiscalYear();
      await this.loadTaxUnit({
        criteria: {
          fiscalYear: maxFiscalYear || this.currentFiscalYear,
        },
        baseCrudKey: 'sharedTaxUnit',
      });
    },
  },
};

</script>
